import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider } from "@chakra-ui/react";
import { Provider } from "react-redux";
import store from "./redux/store";
import { CookiesProvider } from "react-cookie";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotificationContextProvider from "./components/ctx/notificationContext";
import { SocketProvider } from "./socket";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <SocketProvider>
    <CookiesProvider defaultSetOptions={{ path: "/" }}>
      <NotificationContextProvider>
        <Provider store={store}>
          <ToastContainer />
          <ChakraProvider>
            <App />
          </ChakraProvider>
        </Provider>
      </NotificationContextProvider>
    </CookiesProvider>
  </SocketProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
